import { publicClient } from "../Contracts/V3/client";
import { ERC20 } from "../Contracts/V3/abis";

export const readBalance = async (token, owner) => {
  if (!owner) return 0n;
  return publicClient.readContract({
    address: token,
    abi: ERC20,
    functionName: "balanceOf",
    args: [owner],
  });
};
